import FetchModalBasedOnAnchor from "@resources/fetch-modal-based-on-anchor/FetchModalBasedOnAnchor";

window.addEventListener('load', () => {
	FetchModalBasedOnAnchor.registerFetch(
		'fetch',
		'single-staff',
		'single-staff-modal',
		'single-fetch-modal single-fetch-modal--single-staff',
		'#main',
		'.single-fetch-modal--single-staff .back-button'
	)
})


